import React, { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';  
import rehypeKatex from 'rehype-katex';
import { headingTextToSlug } from './BlogPostHeadings';
import { flatten } from './BlogPostHeadings';
import { useMediaQuery } from '@material-ui/core';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { Link as LinkScroll } from 'react-scroll';


const TableOfContents = ( {headings} ) => {
  // Only allow collapsing the TOC on mobile.
  // 1024 is the same value as in the BlogPost Component. Corresponds to 'lg' in tailwindcss.
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isCollappsed, setIsCollapsed] = useState(isMobile);

  useEffect(() => {
    setIsMobile(window.innerWidth < 1024);
    setIsCollapsed(isMobile);
  }, [window.innerWidth])


  return (
    <div className='flex flex-col p-2 border-2 border-dark-accent dark:border-light-accent rounded-xl lg:border-none lg:max-w-xs'>
      {/* The "Contents" header that can be expanded on mobile */}
      <div 
        onClick={() => setIsCollapsed(!isCollappsed)} 
        className='flex items-center space-x-2 font-bold text-xl text-dark-accent dark:text-light-accent hover:opacity-90'
      >
        { isMobile ? (isCollappsed ? <FaChevronRight/> : <FaChevronDown/> ) : null}
        <span>Contents</span>
      </div>
      {/* The TOC */}
      { isMobile & isCollappsed ? null :
      <ul className='text-dark dark:text-light-accent2'>
        {headings.map((heading, idx) => (
          <li 
            key={idx} className={heading.level===0 ? 'font-bold' : ''} 
            style={{
              marginLeft: `${(heading.level)*20}px`, 
              marginBottom: "5px",
              marginTop: idx === 0 ? '20px' : '0px',
            }}
          >
              <ReactMarkdown 
                components={{
                  p: ({children}) => {
                    // Set the ID of the link in the exact same way as when rendering the heading.
                    var p_text = children.reduce(flatten, '');
                    return <LinkScroll to={headingTextToSlug(p_text)} smooth={true} duration={300} spy={true} exact="true" offset={-56} className='hover:cursor-pointer hover:underline'>
                      <p className={'leading-snug'}>{children}</p>
                    </LinkScroll>
                    }
                }}
                children={heading.text}
                remarkPlugins={[remarkMath]}
                rehypePlugins={[rehypeKatex]}
              />
          </li>
        ))}
      </ul>
      }
    </div>
  );
};

export default TableOfContents